import { create } from 'zustand';

export const useMappingDetailsStore = create((set, get) => ({
  // État initial
  mappingDetails: null,

  // Actions
  setMappingDetails: (newMappingDetails) =>
    set({ mappingDetails: newMappingDetails }),

  clearMappingDetails: () => set({ mappingDetails: null }),

  getMappingDetails: () => get().mappingDetails,

  isMappingDetailsLoaded: () => get().mappingDetails !== null,
}));
